import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';
import {
  insertMission,
  copyMission,
  importMission,
  updateMission,
  softDeleteMission,
  restoreMission,
  hardDeleteMission,
  setDoneMission,
  setTakeOffPointMission,
  setLandingPointMission,
  setGeometryMission,
  editWaypointListMission,
  addElevationToGeoJSONMission,
  editElevationProfileMission,
  clearWaypointsMission,
  setLandingBearingMission,
  setFinalWaypointListMission,
  setWaypointTelemetryArray,
  setDistanceTraveledAndFlightTime,
  setAreaMission,
  setPictureGridMission,
  setParamsMission
} from './server/mission-methods-server';

Meteor.methods({
  'missions.insert'(mission) {
    return insertMission(mission);
  },
  'missions.copy'(missionId) {
    return copyMission(missionId);
  },
  'missions.import'(mission, userId = this.userId) {
    return importMission(mission, userId);
  },
  'missions.update'(mission) {
    return updateMission(mission);
  },
  'missions.softDelete'(missionId) {
    softDeleteMission(missionId);
  },
  'missions.restore'(missionId) {
    restoreMission(missionId);
  },
  'missions.hardDelete'(missionId) {
    hardDeleteMission(missionId);
  },
  'missions.setDone'(missionId, setDone) {
    setDoneMission(missionId, setDone);
  },
  'missions.setTakeOffPoint'(missionId, takeOffPoint) {
    setTakeOffPointMission(missionId, takeOffPoint);
  },
  'missions.setLandingPoint'(missionId, landingPoint) {
    setLandingPointMission(missionId, landingPoint);
  },
  'missions.setMissionGeometry'(missionId, missionGeometry) {
    setGeometryMission(missionId, missionGeometry);
  },
  'missions.setMissionParams'(missionId, flightParameters, pictureGrid, waypointReferenceAltitude) {
    setParamsMission(missionId, flightParameters, pictureGrid, waypointReferenceAltitude);
  },
  'missions.editWayPointList'(missionId, newWayPointList) {
    editWaypointListMission(missionId, newWayPointList);
  },
  'missions.addElevationToGeoJSON'(missionId, geojson) {
    return addElevationToGeoJSONMission(missionId, geojson);
  },
  'missions.editElevationProfile'(missionId, elevationProfile) {
    editElevationProfileMission(missionId, elevationProfile);
  },
  'missions.clearWayPoints'(missionId) {
    clearWaypointsMission(missionId);
  },
  'missions.setLandingBearing'(missionId, landingBearing) {
    setLandingBearingMission(missionId, landingBearing);
  },
  'missions.setFinalWaypointList'(missionId, newWayPointList) {
    setFinalWaypointListMission(missionId, newWayPointList);
  },
  'missions.sentWaypointTelemetryArray'(missionId, newWayPointList) {
    setWaypointTelemetryArray(missionId, newWayPointList);
  },
  'missions.setDistanceTraveledAndFlightTime'(missionId, newDistanceTraveled, newFlightTime) {
    setDistanceTraveledAndFlightTime(missionId, newDistanceTraveled, newFlightTime);
  },
  'missions.setMissionArea'(missionId, newMissionArea) {
    setAreaMission(missionId, newMissionArea);
  },
  'missions.setPictureGridData'(missionId, distanceBetweenPics, timeBetweenPics, groundResolution) {
    setPictureGridMission(missionId, distanceBetweenPics, timeBetweenPics, groundResolution);
  }
});

rateLimit({
  methods: [
    'missions.insert',
    'missions.copy',
    'missions.import',
    'missions.update',
    'missions.softDelete',
    'missions.restore',
    'missions.hardDelete',
    'missions.setDone',
    'missions.setLandingPoint',
    'missions.setTakeOffPoint',
    'missions.setMissionGeometry',
    'missions.setMissionParams',
    'missions.editWayPointList',
    'missions.addElevationToGeoJSON',
    'missions.editElevationProfile',
    'missions.clearWayPoints',
    'missions.setLandingBearing',
    'missions.setFinalWaypointList',
    'missions.sentWaypointTelemetryArray',
    'missions.setDistanceTraveledAndFlightTime',
    'missions.setMissionArea',
    'missions.setPictureGridData'
  ],
  limit: 5,
  timeRange: 1000
});
